import { Star } from 'lucide-react';

const REVIEWS = [
  {
    name: "smalldog",
    location: "Sydney, Australia",
    date: "Nov 13, 2022",
    rating: 5,
    title: "Excellent coach",
    service: "Other",
    length: null,
    text: "Hettie is an excellent coach. You are taught four systems: intraday, which is the backbone of her trading, scalping, swing and long term. Every system has very well defined rules and leaves little room for interpretation. You can still apply your judgement and decide if you want to take the trade, but the rules will definitely keep you out of bad ones.\n\nExplanations are very clear, and Hettie doesn't mind explaining things several times. Nothing is rushed, she adapts to your pace, and you can ask as many questions as you want.\n\nGood for beginners and someone with experience in the forex market."
  },
  {
    name: "mmf22",
    location: "Wellington, New Zealand",
    date: "May 23, 2022",
    rating: 5,
    title: "Fantastic forex coach!",
    service: "Live",
    length: "0-3 Months",
    text: "After reading a number of books on how to trade I was unsure on how to get started. Luckily for me I found this forum and decided to enroll with Hettie. That was definitely the smartest decision I could have made as Hettie is a fantastic coach!!\n\nHettie is a straight shooter and made sure from the start that I understood the risks of trading forex and that it is not a 'get rich overnight' scheme.\n\nWhen teaching, she adapted her pace to meet my needs and taught me easy to follow strategies to trade the 5 min, 1 Hour, 4 hour and monthly charts.\n\nI mainly trade the 1 hour and 5 min charts now and of the 24 trades I placed over the last week I made a profit on 23 of them.\n\nHettie is always happy to go with me through my trades and answer questions and to explain to me her thoughts on how to read charts.\n\nI can definitely recommend her as a coach!"
  },
  {
    name: "MY SELF",
    location: "Boston, USA",
    date: "May 8, 2022",
    rating: 5,
    title: "Starting from scratch with Hettie",
    service: "Live",
    length: "0-3 Months",
    text: "Have been tried to trade on my own for almost 5 years before meet Hettie. Had also few coaches but nothing really worked for me. Finally, after enrolled in her course we started few classes after I stopped because had other importance in life. Few months later asked her if we can continue where we stopped so she accepted to start all over again with not charging me anything extra.\n\nShe is such an amazing coach and wonderful person. No matter how many times asking a question she will go again with me until I get it completely. My trading is so clear and precise now. We tuned up my trading style with my personality so it will be something natural and smooth. I am honored that she accepted me as a student and any time I had some question she was always there to answer and hold my hand."
  },
  {
    name: "Claire Richardson",
    location: "Sydney, Australia",
    date: "Nov 12, 2021",
    rating: 5,
    title: "The light at the end of my trading tunnel",
    service: "Live",
    length: "over 1 Year",
    text: "Hettie is a great teacher and have really taken the time to help me with my bad habits. I am a single mum and needed a second income during this pandemic. Hettie has really understood my situation and have spent more time mentoring me through the mistakes that I have previously made. My reading has finally become positive and I have found a new sense of motivation for trading. Thank you for your ongoing support Hettie, you are an amazing mentor!!!"
  },
  {
    name: "pace.d.j",
    location: "Auckland, New Zealand",
    date: "Jan 31, 2021",
    rating: 5,
    title: "Great Teacher of FOREX",
    service: "Live",
    length: "over 1 Year",
    text: "I started my FOREX Trading Course in May 2019. At the time I knew very little about FOREX except that they exist and how much you get for your dollar when you travel. I signed up for the Platinum Package to give me the most education and support about FOREX.\n\nHettie certainly knows how to teach and give a great customer experience. Her one on one training was great fitting in with my challenging shift hours. I had both great teaching and support even replying to my questions when I would consider it after hours.\n\nI have developed my trading using her methods and I find her \"Forex Scalping Strategy\" fits my busy lifestyle. Learning to follow the rules is important as she has taught me that not every situation is right for a trade and \"a no trade is better than a bad trade.\" By following these rules I am now successful in most of my trades. This has given me the confidence to open my Live account.\n\nHettie is an excellent teacher and helps you learn and understand what you need to do if you are serious about learning FOREX."
  },
  {
    name: "Shantel Shaw",
    location: "Miami, FL, USA",
    date: "Dec 22, 2020",
    rating: 5,
    title: "SHE WAS AMAZING!!!!",
    service: "Demo",
    length: "0-3 Months",
    text: "She was the best thing that ever happened to my trading. I learned so much from her and will always be thankful for the knowledge and the confidence that she gave me with trading. She gave me the knowledge to turn a 10k account into 33k in one day. She is the best hands down. I'M SO GLAD I PICKED THE RIGHT INSTRUCTOR!"
  },
  {
    name: "JAH91",
    location: "Kuala Lumpur, Malaysia",
    date: "Oct 29, 2020",
    rating: 5,
    title: "Easy to follow strategies that works.",
    service: "Demo",
    length: "over 1 Year",
    text: "AMAZING!!\n\nI have just completed the Mastery course with Hettie and I must say she really makes it simple to follow. She knows exactly where you need help with all her reviews on the demo trades that you make during the course. The course is on an agreed time suited to both Hettie and I. The course did not take long and she can easily identify your personality type hence the strategy suited for you.\n\nI can confidently say that I am on the road to success.\n\nThank you very much for your time Hettie and I have indeed enjoyed every moment of the course."
  },
  {
    name: "Aristides",
    location: "Sasolburg, South Africa",
    date: "Feb 23, 2020",
    rating: 5,
    title: "Best of the Best Forex Coaching",
    service: "Live",
    length: "0-3 Months",
    text: "I completed my training with Hettie in early November 2019. I immediately funded a live account with $1,000, even though Hettie insisted I demo trade for 3 months minimum. As of today, 24 February 2020, my account balance is $1,769. Hettie will teach you an easy to follow trading system that has stood the test of time. Hettie will teach you how to read charts from monthly down to the 5 minute timeframes. Hettie will teach you how to be a consistently profitable trader.\n\nI wish I done this course in 2013, when I started trading Forex. I would have been a millionaire today!"
  },
  {
    name: "uselessrobot123",
    location: "Mindanao, Philippines",
    date: "Dec 20, 2019",
    rating: 5,
    title: "One of the best if not the best!",
    service: "Other",
    length: "0-3 Months",
    text: "First of all, I would like you guys to know that Hettie is a wonderful person, she knows how to relay her knowledge to the students very well. Even if you have zero knowledge in forex, she will be very effective in teaching you. She is sincere with making her students understand and her goal is for you to really become profitable.\n\nWhen she asks you if you understand the lesson or not, just be honest, she won't judge you, she's very reassuring and when you don't understand it she will repeat it over and over until you get it. She won't leave your questions unanswered.\n\nHer methods are very effective, you can focus on learning because it's a one on one mentoring, you will learn on your own pace with no pressure. I tell you, look no further! She is a mentor you are looking for. My trading turned around because of her guidance. My wrong perception of trading was corrected and now I can safely say that I am confident to face the forex markets.\n\nShe has a way of making complicated topics simple. She will help you determine your trader personality and that really, really helps you in your journey. She's very honest with you and your progress, she will criticize you if needed but no judgement. She just wants the best for her students.\n\n- Christian"
  },
];

export default function ReviewsPage() {
  const avgRating = 4.895;
  const totalReviews = 71;

  return (
    <div className="min-h-screen pt-24 pb-20" data-testid="reviews-page">
      {/* Hero */}
      <section className="px-4 sm:px-6 lg:px-8 pb-16 text-center relative overflow-hidden">
        <div className="absolute top-0 left-1/2 w-96 h-96 rounded-full bg-amber-400/[0.03] blur-[120px] -translate-x-1/2" />
        <div className="relative mx-auto max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-500 mb-3">Forex Peace Army Verified</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-white leading-tight">Trader Reviews</h1>
          <p className="mt-5 text-sm text-slate-400 max-w-xl mx-auto leading-relaxed">
            Real reviews from real traders on Forex Peace Army. See why hundreds of traders trust Hettie Nel's training and tools.
          </p>
          <div className="mt-6 inline-flex items-center gap-3 px-6 py-3 rounded-2xl bg-[#0a0f1c] border border-white/10">
            <div className="flex">
              {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-amber-500 text-amber-500" />)}
            </div>
            <span className="text-2xl font-bold text-white">{avgRating}</span>
            <span className="text-slate-400 text-sm">/ 5</span>
            <span className="text-slate-500 text-sm">({totalReviews} reviews)</span>
          </div>
        </div>
      </section>

      {/* Reviews list */}
      <section className="px-4 sm:px-6 lg:px-8 py-12" data-testid="reviews-list">
        <div className="mx-auto max-w-3xl space-y-5">
          {REVIEWS.map((r, i) => (
            <div key={i} className="rounded-2xl border border-white/10 bg-[#0a0f1c] p-6" data-testid={`review-${i}`}>
              <div className="flex items-start justify-between gap-4 mb-4">
                <div>
                  <div className="flex gap-0.5 mb-2">
                    {[...Array(r.rating)].map((_, j) => <Star key={j} size={14} className="fill-amber-500 text-amber-500" />)}
                  </div>
                  <h3 className="text-lg font-bold text-white">{r.title}</h3>
                </div>
                <div className="text-right shrink-0">
                  {r.service && <p className="text-[10px] text-slate-600">Service: {r.service}</p>}
                  {r.length && <p className="text-[10px] text-slate-600">Length: {r.length}</p>}
                </div>
              </div>
              <p className="text-sm text-slate-300 leading-relaxed whitespace-pre-line">{r.text}</p>
              <div className="mt-4 pt-3 border-t border-white/[0.06] flex items-center gap-2">
                <div className="w-7 h-7 rounded-full bg-amber-500/10 flex items-center justify-center text-amber-500 text-xs font-bold">
                  {r.name.charAt(0).toUpperCase()}
                </div>
                <div>
                  <p className="text-sm font-medium text-white/80">{r.name}</p>
                  <p className="text-[11px] text-slate-500">{r.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* External link */}
      <section className="px-4 sm:px-6 lg:px-8 py-12 text-center">
        <a
          href="https://www.forexpeacearmy.com/forex-reviews/3633/oneononeforextraining-review"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-amber-500/30 text-amber-500 text-sm font-bold hover:bg-amber-500/10 transition-colors"
          data-testid="fpa-link"
        >
          View All {totalReviews} Reviews on Forex Peace Army
        </a>
        <p className="mt-3 text-[11px] text-slate-500">Reviews sourced from ForexPeaceArmy.com — verified trader reviews</p>
      </section>
    </div>
  );
}
